import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-3xl text-primary-600">
          <i className="ri-film-line"></i>
        </div>
        <p className="mt-6 font-heading text-6xl font-semibold text-primary-500">404</p>
        <h1 className="mt-4 font-heading text-xl font-semibold text-foreground-900 md:text-2xl">
          这个页面还没有内容
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的页面可能已移动或尚未生成。不如从剧情、演员或精彩片段里，找找你想看的内容。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>返回首页
          </Link>
          <Link
            to="/category/story"
            className="inline-flex items-center gap-2 rounded-md border border-background-300/80 px-5 py-2.5 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-book-2-line"></i>浏览剧情
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}